import { render, staticRenderFns } from "./editWordPage.vue?vue&type=template&id=b04dcd0c&"
import script from "./editWordPage.vue?vue&type=script&lang=js&"
export * from "./editWordPage.vue?vue&type=script&lang=js&"
import style0 from "./editWordPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports